import { render, staticRenderFns } from "./GraficoResultadoPorMotivo.vue?vue&type=template&id=0deceb51&scoped=true"
import script from "./GraficoResultadoPorMotivo.vue?vue&type=script&lang=ts"
export * from "./GraficoResultadoPorMotivo.vue?vue&type=script&lang=ts"
import style0 from "./GraficoResultadoPorMotivo.vue?vue&type=style&index=0&id=0deceb51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deceb51",
  null
  
)

export default component.exports